import React, { useState, useEffect, useCallback } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const CONSENT_KEY = "sc_cookie_consent";
const GA_ID = "G-43JS5VRZ5T";
const META_PIXEL_ID = "967471005943463";

function injectGoogleAnalytics() {
  if (document.getElementById("sc-ga-script")) return;
  const script = document.createElement("script");
  script.id = "sc-ga-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
}

function injectMetaPixel() {
  if (window.fbq) return;
  (function (f, b, e, v, n, t, s) {
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
}

function loadTrackingScripts() {
  injectGoogleAnalytics();
  injectMetaPixel();
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === "accepted") {
      loadTrackingScripts();
    } else if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
    loadTrackingScripts();
  }, []);

  const handleDecline = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: "rgba(0, 0, 0, 0.92)",
        color: "#fff",
        px: { xs: 2, sm: 4 },
        py: 2,
        zIndex: 9999,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        gap: 2,
      }}
    >
      <Typography variant="body2" sx={{ flex: 1 }}>
        This site uses cookies and tracking technologies, including the Meta Pixel and Google Analytics, to improve your experience and serve relevant advertising. See our{" "}
        <RouterLink to="/privacy" style={{ color: "#90caf9", textDecoration: "underline" }}>
          Privacy Policy
        </RouterLink>
        .
      </Typography>
      <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
        <Button variant="outlined" size="small" onClick={handleDecline} sx={{ color: "#fff", borderColor: "rgba(255,255,255,0.5)", "&:hover": { borderColor: "#fff", bgcolor: "rgba(255,255,255,0.1)" } }}>
          Decline
        </Button>
        <Button variant="contained" size="small" onClick={handleAccept}>
          Accept
        </Button>
      </Box>
    </Box>
  );
}
